











































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import Input from '@/main-components/common/Input.vue';
import CameraUpload from '@/main-components/common/CameraUpload.vue';
import { GradeAnswerSheet } from '@/resource/grade/grade.model';
import { uploadImages } from '@/utils/grade';
import { OnSubmitInput } from '../Form.vue';
import { axios } from '@/utils/axios';

@Component({
  components: {
    Input,
    CameraUpload,
    Modal,
    MainButton,
  },
})
export default class ModalAnswerSheet extends Vue {
  openModal: any = null;
  closeModal: any = null;

  @Prop({ required: true })
  gradeAnswerSheet: GradeAnswerSheet | null;

  @Prop({ required: true })
  gradePaperUuid: string;

  isLoading = false;
  imagesObject: { images: string[] } = { images: [] };

  @Watch('gradeAnswerSheet')
  gradeAnswerSheetUpdated() {
    if (this.gradeAnswerSheet) {
      this.imagesObject = { images: this.gradeAnswerSheet.images };
    } else {
      this.imagesObject = { images: [] };
    }
  }

  mounted() {
    this.$emit('openModalAnswerSheetAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async addAnswerSheet() {
    if (this.isLoading) return;
    this.isLoading = true;

    if (!this.imagesObject.images.length) {
      this.$toasted.global.mainToast({
        message: 'Please add at least one image',
      });
      this.isLoading = false;
      return;
    }

    const nameInput = (await (this.$refs
      .nameInput as any).submitInput()) as OnSubmitInput;

    if (nameInput && nameInput.hasError) {
      this.isLoading = false;
      return;
    }

    const name = nameInput.value as string;

    const images = await uploadImages(this.imagesObject.images);

    const response = await this.createAnswerSheet({ name, images });

    if (response) {
      this.$emit('refetchAnswerSheets');
      this.closeModal && this.closeModal();
    }

    this.isLoading = false;
  }

  async createAnswerSheet(params: { name: string; images: string[] }) {
    try {
      const { data } = await axios.post(
        `/grade-papers/${this.gradePaperUuid}/grade-answer-sheets`,
        {
          student: { name: params.name },
          images: params.images,
        },
      );

      if (data) {
        this.$toasted.global.mainToast({
          message: 'Answer sheet successfully added.',
        });
        return data;
      }
    } catch (error) {
      this.$toasted.global.mainToast({
        message: error,
      });
    }
  }
}
